import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Navigate } from 'react-router-dom';
import { useAuth } from '@state/index';
import { FullPageSpinner } from '@components/index';
export function AdminRoute({ children }) {
    const { user, isLoading } = useAuth();
    if (isLoading) {
        return _jsx(FullPageSpinner, {});
    }
    if (!user || user.role !== 'admin') {
        return _jsx(Navigate, { to: "/", replace: true });
    }
    return _jsx(_Fragment, { children: children });
}
